import { useNavigate } from 'react-router-dom'
import { ExternalLink } from 'lucide-react'

interface OrgCardProps {
  org: {
    id: string
    name: string
    email?: string
    status?: string
    plan_name?: string
    expires_at?: string
    user_count?: number
  }
}

function StatusBadge({ status }: { status?: string }) {
  const map: Record<string, { label: string; color: string; bg: string }> = {
    active: { label: 'Active', color: '#22c55e', bg: '#22c55e20' },
    expired: { label: 'Expired', color: '#ef4444', bg: '#ef444420' },
    trial: { label: 'Trial', color: '#f59e0b', bg: '#f59e0b20' },
    inactive: { label: 'Inactive', color: '#6b7280', bg: '#6b728020' },
  }
  const s = map[status ?? ''] ?? { label: status ?? '—', color: '#9ca3af', bg: '#9ca3af20' }
  return (
    <span
      className="px-2.5 py-1 rounded-full text-xs font-medium"
      style={{ color: s.color, background: s.bg }}
    >
      {s.label}
    </span>
  )
}

export { StatusBadge }

export default function OrgCard({ org }: OrgCardProps) {
  const navigate = useNavigate()
  return (
    <div
      className="rounded-xl p-5 cursor-pointer transition-colors hover:border-indigo-500/50"
      style={{ background: '#252836', border: '1px solid #2d3148' }}
      onClick={() => navigate(`/organizations/${org.id}`)}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-white font-semibold truncate">{org.name}</div>
          {org.email && (
            <div className="text-sm mt-0.5 truncate" style={{ color: '#9ca3af' }}>{org.email}</div>
          )}
        </div>
        <ExternalLink size={16} style={{ color: '#6b7280', flexShrink: 0 }} />
      </div>
      <div className="flex items-center gap-3 mt-3 flex-wrap">
        <StatusBadge status={org.status} />
        {org.plan_name && (
          <span className="text-xs px-2.5 py-1 rounded-full" style={{ color: '#a5b4fc', background: '#6366f120' }}>
            {org.plan_name}
          </span>
        )}
      </div>
      {org.expires_at && (
        <div className="text-xs mt-2" style={{ color: '#6b7280' }}>
          Expires: {new Date(org.expires_at).toLocaleDateString()}
        </div>
      )}
    </div>
  )
}
